import { computed, reactive, toRefs } from "vue"

const state = reactive({
    notifications: [],
    piutangJatuhTempo: []
})

const notifCount = computed(() => state.notifications.length )

function setItem(data) {
    state.notifications = Array.isArray(data) ? data : []
}

function setPiutang(data) {
    state.piutangJatuhTempo = Array.isArray(data) ? data : []
}

function resetItem() {
    state.notifications = []
}

export function useNotifStore() {
    return {
        ...toRefs(state),
        notifCount,
        setItem,
        setPiutang,
        resetItem
    }
}